import { render, staticRenderFns } from "./breadcrumb2.vue?vue&type=template&id=06fb8b2e&scoped=true"
import script from "./breadcrumb2.vue?vue&type=script&lang=js"
export * from "./breadcrumb2.vue?vue&type=script&lang=js"
import style0 from "./breadcrumb2.vue?vue&type=style&index=0&id=06fb8b2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fb8b2e",
  null
  
)

export default component.exports